import React, {useMemo, useState} from 'react'
import {Input, Modal} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {Box, Text} from "grommet";
import {BridgeToken} from "../../api/bridge";

export interface TokenSelectProps {
  tokens: BridgeToken[]
  token?: BridgeToken
  onChange: (token: BridgeToken) => void
}

export const TokenSelect = (props: TokenSelectProps) => {
  const [filterName, setFilterName] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tokensList = useMemo(() => {
    return props.tokens.filter(item =>
      item.symbol.toLowerCase().includes(filterName.toLowerCase())
      || item.name.toLowerCase().includes(filterName.toLowerCase())
    )
  }, [props.tokens, filterName])

  return <Box direction={'row'}>
    <Box
      width={'100%'}
      direction={'row'}
      align={'center'}
      justify={'between'}
      height={'38px'}
      onClick={() => setIsModalOpen(true)}
    >
      <Box direction={'row'} align={'baseline'} gap={'6px'}>
        <Text size={'26px'}>{props.token?.symbol || 'Choose token'}</Text>
        <Text size={'18px'} color={'gray'}>{props.token?.name || ''}</Text>
        <Text>▼</Text>
      </Box>
    </Box>
    <Modal
      title="Choose token"
      open={isModalOpen}
      okButtonProps={{ disabled: true }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
      forceRender={true}
    >
      <Box>
        <Box>
          <Input
            placeholder={'Search token name'}
            prefix={<SearchOutlined />}
            onChange={(e) => setFilterName(e.target.value)}
          />
        </Box>
        <Box margin={{ top: '16px' }}>
          {tokensList.map(token =>
            <Box direction={'row'} height={'32px'} gap={'6px'} onClick={() => {
              props.onChange(token)
              setIsModalOpen(false)
            }}>
              <Text>{token.symbol}</Text>
              <Text color={'gray'} size={'small'}>{token.name}</Text>
            </Box>
        )}
        </Box>
      </Box>
    </Modal>
  </Box>
}
